import { render, staticRenderFns } from "./WorklistFilters.vue?vue&type=template&id=55023a51&scoped=true"
import script from "./WorklistFilters.vue?vue&type=script&lang=js"
export * from "./WorklistFilters.vue?vue&type=script&lang=js"
import style0 from "./WorklistFilters.vue?vue&type=style&index=0&id=55023a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55023a51",
  null
  
)

export default component.exports